exports.list = {
    path: '/laporan_piutang_dagang',
    name: 'laporan_piutang_dagang', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_piutang_dagang/List.vue"),
  }
  